import getTransitionProperties from './getTransitionProperties';
export default function getTransitionEnd() {
  return getTransitionProperties().end;
}